import { Routes } from '@angular/router';
import { PUBLIC_LOGIN_PATH } from './constants/NextGenConstants';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { SelectEntitlementGroupComponent } from './auth/select-entitlement-group/select-entitlement-group.component';
import { PostLoginAgreementComponent } from './auth/post-login-agreement/post-login-agreement.component';
import { NextGenShellComponent } from './common/components/nextgen-shell/nextgen-shell.component';
import { authenticationGuard } from './services/guards/authentication-guard';
import { authorizationGuard } from './services/guards/authorization-guard';

export const routes: Routes = [
  // FNX NextGen
  {
    path: 'public',
    loadChildren: () =>
      import('./public/public.routes').then((m) => m.PUBLIC_ROUTES),
  },
  {
    path: 'funds',
    canActivate: [authenticationGuard],
    children: [
      { path: '', redirectTo: 'reporting', pathMatch: 'full' },
      {
        path: 'auth',
        component: NextGenShellComponent,
        children: [
          // Post-login User agreement
          {
            path: 'userAgreement',
            title: 'User Agreement',
            component: PostLoginAgreementComponent,
            pathMatch: 'full',
          },
          // Authenticated users to select an investment firm from a list
          {
            path: 'selectFirm',
            title: 'Select Investment Firm',
            component: SelectEntitlementGroupComponent,
            pathMatch: 'full',
          },
          // Authenticated users trying to reset password
          {
            path: 'reset',
            title: 'Password Reset',
            component: ResetPasswordComponent,
            pathMatch: 'full',
            canActivate: [authorizationGuard],
          },
        ],
      },
      // Reporting UI
      {
        path: 'reporting',
        title: 'Sales & Reporting',
        loadChildren: () =>
          import('./reporting/reporting.routes').then(
            (m) => m.REPORTING_ROUTES,
          ),
      },
    ],
  },

  // Wildcard
  { path: '**', redirectTo: PUBLIC_LOGIN_PATH },
];
